import { DELIVERY_OPTION } from '@utils/constant';

/** @param {Array} deliveryOptions
 * @param {String} deliveryOptionId*/
export const isCartLineItemSelectBOPISOption = (deliveryOptions, deliveryOptionId) => deliveryOptions?.find((item) => item.ExternalId
  === deliveryOptionId)?.ShippingOptionType?.Value === DELIVERY_OPTION.PickUpStore;